const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentForm extends HTMLElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		this.watchForFormLoad();
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
	}

	get formElement() {
		return this.querySelector('form');
	}

	onFormLoad() {
		const placeholderContainerElement = this.querySelector('.component-form__form-placeholder');
		if (placeholderContainerElement) {
			placeholderContainerElement.remove();
		}
	}

	watchForFormLoad() {
		new Promise(resolve => {
			if (this.formElement) {
				return resolve(this.formElement);
			}
			const observer = new MutationObserver(mutations => {
				if (this.formElement) {
					observer.disconnect();
					resolve(this.formElement);
				}
			});
			observer.observe(this, {
				childList: true,
				subtree: true
			});
		}).then((form) => {
			this.onFormLoad();
		});
	}

}

customElements.define('component-form', ComponentForm, {extends: 'section'});